import { render, staticRenderFns } from "./DashAdminReferral.vue?vue&type=template&id=469efeb0&scoped=true&"
import script from "./DashAdminReferral.vue?vue&type=script&lang=js&"
export * from "./DashAdminReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469efeb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
